import liveSettings from './settings.live.json'
import uatSettings from './settings.uat.json'
import productionSettings from './settings.production.json'
import demoSettings from './settings.demo.json'
import developmentSettings from './settings.development.json'
import validateSettings from './settings.validate.json'
import tempSettings from './settings.temp.json'

const localHostnames = ['local.test', 'localhost']

const settings = () => {
	let envSettings = developmentSettings
	if (process.env.CONF_ENV === 'live') {
		envSettings = liveSettings
	} else if (process.env.CONF_ENV === 'uat') {
		envSettings = uatSettings
	} else if (process.env.CONF_ENV === 'production') {
		envSettings = productionSettings
	} else if (process.env.CONF_ENV === 'demo') {
		envSettings = demoSettings
	} else if (process.env.CONF_ENV === 'development') {
		envSettings = developmentSettings
	} else if (process.env.CONF_ENV === 'validate') {
		envSettings = validateSettings
	} else if (process.env.CONF_ENV === 'temp') {
		envSettings = tempSettings
	}

	// local overrides
	if (global.document && localHostnames.includes(global.document.location.hostname)) {
		envSettings.options = {
			...envSettings.options,
			...envSettings.options.local
		}
		//	Only log in the browser
		if (process.env.JEST_WORKER_ID === undefined && process.env.CONF_ENV) {
			console.log(`Starting locally to ${process.env.CONF_ENV}`, envSettings)
		}
	}
	delete envSettings.options.local

	return envSettings
}

export default settings()



// WEBPACK FOOTER //
// ./config/settings.js